import { render, staticRenderFns } from "./UpdateRankSettings.vue?vue&type=template&id=7df927e0&scoped=true"
import script from "./UpdateRankSettings.vue?vue&type=script&lang=js"
export * from "./UpdateRankSettings.vue?vue&type=script&lang=js"
import style0 from "./UpdateRankSettings.vue?vue&type=style&index=0&id=7df927e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df927e0",
  null
  
)

export default component.exports